export default __webpack_public_path__ + "static/media/icon-x-circle.e78317d9.svg";